/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActiveStep/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Fixed from './Fixed/index'
import ListType from './ListType/index'
import No from './No/index'
import None from './None/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ActiveStep({
  children,
  viewPath = "/DesignSystem/AppsLauncherProperties/Content/ActiveStep"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedSourceValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'source',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: selectedSourceValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Fixed'}>
<Fixed
  viewPath={`${viewPath}/Fixed`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ListType'}>
<ListType
  viewPath={`${viewPath}/ListType`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'None'}>
<None
  viewPath={`${viewPath}/None`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}